module.exports = __webpack_public_path__ + "media/images/home-promo-1-f65677247f590015db906b4e6304e75f.jpg";